import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import * as Yup from "yup";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  loading: boolean;
  initialValues: {
    name: string;
    hours: string;
    color: string;
  };
  addBtnLoading: boolean;
  snackbar: {
    open: boolean;
    severity: "error" | "success" | "info" | "warning" | undefined;
    message: string;
  };
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class AddLateDeliveryConfigController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  addLateDeliveryConfigCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
      // Customizable Area Start
      loading: false,
      initialValues: {
        name: "",
        hours: "",
        color: "#000000",
      },
      addBtnLoading: false,
      snackbar: {
        open: false,
        severity: "info",
        message: "",
      },
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (getName(MessageEnum.RestAPIResponceMessage) !== message.id) {
      return;
    }

    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (apiRequestCallId === this.addLateDeliveryConfigCallId) {
      this.handleAddResponse(responseJson);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
  }

  FormSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    hours: Yup.string()
      .required("Hours is required")
      .matches(/^\d+$/, "Hours must be a valid number")
      .test(
        "positive-number",
        "Hours must be greater than 0",
        (value) => {
          const numericValue = parseInt(value);
          return !isNaN(numericValue) && numericValue > 0;
        }
      ),
    color: Yup.string().required("Color is required"),
  });

  handleAddResponse = (responseJson: any) => {
    if (responseJson !== undefined && responseJson.error === undefined) {
      this.setState({
        snackbar: {
          message: "Late Delivery Config added successfully",
          severity: "success",
          open: true,
        },
      });

      setTimeout(() => {
        this.props.navigation.navigate("LateDeliveryList");
      }, 2000);
    } else {
      this.setState({
        addBtnLoading: false,
        snackbar: {
          message: responseJson?.errors?.[0]?.message || "Failed to add configuration",
          severity: "error",
          open: true,
        },
      });
    }
  };

  addLateDeliveryConfig = (values: any) => {
    this.setState({
      addBtnLoading: true,
    });

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const httpBody = {
      data: {
        name: values.name,
        hours: parseInt(values.hours),
        color: values.color,
        is_active: true,
      },
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.addLateDeliveryConfigCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.LateDeliveryListPage.ApiUrls.getLateDeliveryList
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCloseSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        severity: "info",
        message: "",
      },
    });
  };

  handleCancelForm = () => {
    this.props.navigation.navigate("LateDeliveryList");
  };
  // Customizable Area End
}
